module.exports = __webpack_public_path__ + "img/19-3.a2e3d5a4.png";